export default function AttachPreparationItemDocumentController(
  $rootScope,
  $scope,
  $q,
  $filter,
  $timeout,
  ssDialogService,
  loaderService,
  alerts,
  userService,
  amDataService
) {
  const vm = this;

  vm.handleAttachDocument = _handleAttachDocument;
  vm.handleDownloadDocument = _handleDownloadDocument;
  _activate();

  /** **********************************************
   * Event Handlers
   */

  function _handleAttachDocument() {
    const dfdSave = $q.defer();

    if (vm.document.attached) {
      amDataService
        .attachPreparationItemDocument(vm.preparationItemId, vm.document.documentId, vm.document.name)
        .then(response => {
          if (!response.data) {
            alerts.error('Error occurred while attaching the Document.');
            dfdSave.reject();
          } else {
            alerts.success(`Document ${vm.document.name} has been attached successfully.`);
            vm.document.preparationItemDocumentId = response.data.preparationItemDocumentId;
            $rootScope.$broadcast('refreshAMPreparationItemDocuments', { preparationItemId: vm.preparationItemId });
            // ssDialogService.hide(ssDialogService.dialog.auditTrail.editPreparationItemCommentDialog);
            dfdSave.resolve();
          }
        });
    } else {
      amDataService.detachPreparationItemDocument(vm.document.preparationItemDocumentId).then((response) => {
        if (!response.status === 200) {
          alerts.error('Error occurred while detaching the Document.');
          dfdSave.reject();
        } else {
          alerts.success(`Document ${vm.document.name} has been detached successfully.`);
          vm.document.preparationItemDocumentId = null;
          $rootScope.$broadcast('refreshAMPreparationItemDocuments', { preparationItemId: vm.preparationItemId });
          // ssDialogService.hide(ssDialogService.dialog.auditTrail.editPreparationItemCommentDialog);
          dfdSave.resolve();
        }
      });
    }
  }

  function _handleDownloadDocument() {
    /*
    var $ifrmDownloadFile = angular.element('#ifrmDownloadFile');
    var $frmDownloadFile = angular.element(
    '<form id="frmDownloadFile" method="get" target="ifrmDownloadFile"></form>'
    ).appendTo($ifrmDownloadFile);
    $frmDownloadFile.attr('action', paths.handlerDirectory + 'AM/LargeFileHandler.ashx');
    $frmDownloadFile.append('<input type="hidden" name="auditPackageId" value="' + vm.auditPackageId + '" />');
    $frmDownloadFile.submit();
    */
  }

  /** **********************************************
   * Private Functions
   */

  function _activate() {
    vm.canExpand = vm.status !== 'No Document Added';
    vm.isExpanded = false;
    vm.loading = false;
    userService.getUserPermissionSet('auditTrail').then((permissions) => {
      vm.permissions = permissions;
    });
  }
}

AttachPreparationItemDocumentController.$inject = [
  '$rootScope',
  '$scope',
  '$q',
  '$filter',
  '$timeout',
  'ssDialogService',
  'loaderService',
  'alerts',
  'userService',
  'amDataService'
];
